var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tooltip)?_c('label',{attrs:{"for":_vm.context.id},domProps:{"innerHTML":_vm._s(_vm.tooltip)}}):_c('label',{attrs:{"for":_vm.context.id}},[_vm._v(" "+_vm._s(_vm.context.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }